/* eslint-disable default-param-last */
export const types = {
  SEND_RETARGETING: 'FORM_BAF/SEND_RETARGETING',
  SET_SEGMENT: 'FORM_BAF/SET_SEGMENT',
  INIT_PURCHASE: 'FORM_BAF/INIT_PURCHASE',
  INIT_PURCHASE_SUCCESS: 'FORM_BAF/INIT_PURCHASE_SUCCESS',
  SET_INFO: 'FORM_BAF/SET_INFO',
  SET_INFO_SUCCESS: 'FORM_BAF/SET_INFO_SUCCESS',
  CHECKOUT_REQUEST: 'FORM_BAF/CHECKOUT_REQUEST',
  CHECKOUT_REQUEST_SUCCESS: 'FORM_BAF/CHECKOUT_REQUEST_SUCCESS',
  SEND_PURCHASE_OTP: 'FORM_BAF/SEND_PURCHASE_OTP',
  VALIDATE_PURCHASE_OTP: 'FORM_BAF/VALIDATE_PURCHASE_OTP',
  PROCESS_ORDER: 'FORM_BAF/PROCESS_ORDER',
  PROCESS_ORDER_SUCCESS: 'FORM_BAF/PROCESS_ORDER_SUCCESS',
  STUDENT_RETARGETING: 'FORM_BAF/STUDENT_RETARGETING',
  STUDENT_RETARGETING_SUCCESS: 'FORM_BAF/STUDENT_RETARGETING_SUCCESS',
  STUDENT_RETARGETING_FAIL: 'FORM_BAF/STUDENT_RETARGETING_FAIL',
};

export const actions = {
  sendStudentRetargeting: (data) => ({
    type: types.STUDENT_RETARGETING,
    payload: { data },
  }),
  sendStudentRetargetingSuccess: (data) => ({
    type: types.STUDENT_RETARGETING_SUCCESS,
    payload: { data },
  }),
  sendStudentRetargetingFail: (data) => ({
    type: types.STUDENT_RETARGETING_FAIL,
    payload: { data },
  }),
  sendRetargeting: (data) => ({
    type: types.SEND_RETARGETING,
    payload: { data },
  }),
  setSegment: (data) => ({
    type: types.SET_SEGMENT,
    payload: { data },
  }),
  initPurchase: (data) => ({
    type: types.INIT_PURCHASE,
    payload: { data },
  }),
  initPurchaseSuccess: (data) => ({
    type: types.INIT_PURCHASE_SUCCESS,
    payload: { data },
  }),
  setInfo: (data) => ({
    type: types.SET_INFO,
    payload: { data },
  }),
  setInfoSuccess: (data) => ({
    type: types.SET_INFO_SUCCESS,
    payload: { data },
  }),
  checkout: (data) => ({
    type: types.CHECKOUT_REQUEST,
    payload: { data },
  }),
  checkoutSuccess: (data) => ({
    type: types.CHECKOUT_REQUEST_SUCCESS,
    payload: { data },
  }),
  sendSmsOtp: (data) => ({
    type: types.SEND_PURCHASE_OTP,
    payload: { data },
  }),
  validateSmsOtp: (data) => ({
    type: types.VALIDATE_PURCHASE_OTP,
    payload: { data },
  }),
  processOrder: (data) => ({
    type: types.PROCESS_ORDER,
    payload: { data },
  }),
  processOrderSuccess: (data) => ({
    type: types.PROCESS_ORDER_SUCCESS,
    payload: { data },
  }),
};

const initialState = {
  segment: null,
  loadingForm: false,
  loadingShoppingCart: false,
  initialShoppingCart: null,
  shoppingCart: null,
  customerInfo: null,
  processingOrder: false,
  checkout: false,
  promoRetargetingData: null,
  sendingStudentRetargeting: false,
  sentStudentRetargeting: false,
  studentRetargetingFail: false,
};

function reducer(state = { ...initialState }, action) {
  switch (action.type) {
    case types.SET_SEGMENT: {
      const { data } = { ...action.payload };
      const { segment } = { ...data };
      return {
        ...state,
        segment,
      };
    }
    case types.INIT_PURCHASE: {
      return {
        ...state,
        loadingForm: true,
      };
    }
    case types.INIT_PURCHASE_SUCCESS: {
      const { data } = { ...action.payload };
      const { shoppingCartInfoNormalized, customerInfoNormalized, nextSteps } =
        {
          ...data,
        };
      return {
        ...state,
        loadingForm: false,
        initialShoppingCart: shoppingCartInfoNormalized,
        shoppingCart: shoppingCartInfoNormalized,
        customerInfo: customerInfoNormalized,
        nextSteps,
      };
    }
    case types.SET_INFO: {
      const { data } = { ...action.payload };
      const { skipCheckCoverage } = { ...data };
      return {
        ...state,
        loadingShoppingCart: !skipCheckCoverage,
      };
    }
    case types.SET_INFO_SUCCESS: {
      const { data } = { ...action.payload };
      return {
        ...state,
        loadingShoppingCart: false,
        shoppingCart: data,
      };
    }
    case types.CHECKOUT_REQUEST: {
      return {
        ...state,
        checkout: true,
      };
    }
    case types.CHECKOUT_REQUEST_SUCCESS: {
      const { data } = { ...action.payload };
      const { promoRetargetingData } = data;
      return {
        ...state,
        checkout: false,
        promoRetargetingData,
      };
    }
    case types.PROCESS_ORDER: {
      return {
        ...state,
        processingOrder: true,
      };
    }
    case types.PROCESS_ORDER_SUCCESS: {
      return {
        ...state,
        processingOrder: false,
      };
    }
    case types.STUDENT_RETARGETING: {
      return {
        ...state,
        sendingStudentRetargeting: true,
      };
    }
    case types.STUDENT_RETARGETING_SUCCESS: {
      return {
        ...state,
        sendingStudentRetargeting: false,
        sentStudentRetargeting: true,
        studentRetargetingFail: false,
      };
    }
    case types.STUDENT_RETARGETING_FAIL: {
      return {
        ...state,
        sendingStudentRetargeting: false,
        sentStudentRetargeting: false,
        studentRetargetingFail: true,
      };
    }
    default:
      return state;
  }
}

export default reducer;
